import React from 'react';
import Modal from '../../ModalConversion';
import { AccountForm } from './AccountForm';

export function AccountModal({ isOpen, onClose, initial, isNew, onSave, saving }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <div className="p-4">
                <h4 className="text-white mb-3">{isNew ? 'Nueva cuenta' : 'Editar cuenta'}</h4>
                <AccountForm
                    initial={initial}
                    isNew={isNew}
                    onSubmit={onSave}
                    saving={saving}
                    onCancel={onClose}
                />
            </div>
        </Modal>
    );
}

export default AccountModal;